export type SingleActivity = {
	interactionId: number;
	eventDate: string;
	eventCode: string;
	performedBy: string;
	accountId: number;
	businessId: string;
	createdBy: number;
};

const model: types.models.InputModel = {
	interactionId: 'interactionId',
	eventDate: 'eventDate',
	eventCode: 'eventCode',
	performedBy: 'performedBy',
	accountId: 'accountId',
	businessId: 'businessId',
	createdBy: 'createdBy',
};

export default model;
